<div class="min-h-screen flex flex-col">
    <app-header></app-header>
    <main class="flex-1 w-full max-w-[1920px] mx-auto p-8">
        <router-outlet></router-outlet>
    </main>
</div>

<p-dialog [visible]="showTour()" (visibleChange)="showTour.set($event)" [modal]="true" [showHeader]="false"
    [dismissableMask]="true" [style]="{ width: '640px', maxWidth: '92vw' }"
    contentStyleClass="!p-0 !rounded-2xl overflow-hidden">
    <app-tour (close)="showTour.set(false)" />
</p-dialog>
